import { motion } from "framer-motion";
import { Clock, Clapperboard, Printer, Contrast, Check, Plus, Sparkles } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { fireConfetti } from "../lib/site";
import { useBooking } from "../lib/booking";
import { useContent } from "../lib/content";

export const addonIcon = (title) => {
  const t = title.toLowerCase();
  if (t.includes("hour")) return Clock;
  if (t.includes("video") || t.includes("film")) return Clapperboard;
  if (t.includes("print")) return Printer;
  if (t.includes("b&w") || t.includes("glam")) return Contrast;
  return Sparkles;
};

export const Addons = () => {
  const { addons, toggleAddon } = useBooking();
  const { addons: addonList } = useContent();
  return (
  <section id="addons" className="py-24 lg:py-32 bg-[#3c003a] relative grain overflow-hidden" data-testid="addons-section">
    <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
      <Chapter number="03" label="Level Up Your Event" dark />
      <div className="grid lg:grid-cols-2 gap-6 items-end mb-14">
        <Reveal>
          <h2 className="font-serif text-white text-3xl sm:text-4xl lg:text-5xl tracking-[-0.02em] leading-[1.1]">
            The <em className="text-[#c9006f]">finishing touches</em>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-white/60 text-base md:text-lg leading-[1.7] lg:max-w-md lg:ml-auto">
            Curated upgrades that turn a great booth into the talk of the evening.
          </p>
        </Reveal>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {addonList.map((addon, i) => {
          const Icon = addonIcon(addon.title);
          const added = addons.some((a) => a.title === addon.title);
          const slug = addon.title.toLowerCase().replace(/[^a-z0-9]+/g, "-");
          return (
            <Reveal key={addon.id || addon.title} delay={i * 0.08}>
              <motion.div
                whileHover={{ y: -6 }}
                transition={{ duration: 0.35 }}
                className={`card-glow-hover h-full rounded-3xl bg-white/[0.06] border backdrop-blur-md p-7 flex flex-col transition-colors duration-300 ${
                  added ? "border-[#c9006f]" : "border-white/10"
                }`}
                data-testid={`addon-card-${slug}`}
              >
                <span className="grid place-items-center w-12 h-12 rounded-2xl bg-[#c9006f]/15 text-[#ffc4e4] mb-6">
                  <Icon size={22} strokeWidth={1.6} />
                </span>
                <h3 className="font-serif text-white text-xl mb-2 leading-snug">{addon.title}</h3>
                <p className="text-white/55 text-sm leading-relaxed flex-1 mb-6">{addon.desc}</p>
                <p className="font-serif text-[#c9006f] text-3xl mb-6">
                  ${addon.price}
                  <span className="text-base text-white/40 font-sans">{addon.unit}</span>
                </p>
                <button
                  onClick={(e) => {
                    if (!added) fireConfetti(e);
                    toggleAddon(addon.title, addon.price);
                  }}
                  data-testid={`addon-toggle-${slug}`}
                  className={`w-full rounded-full py-3 text-sm font-bold tracking-wide flex items-center justify-center gap-2 transition-all duration-300 ${
                    added
                      ? "bg-[#c9006f] text-white"
                      : "border border-white/25 text-white hover:border-[#c9006f] hover:text-[#ffc4e4]"
                  }`}
                >
                  {added ? <Check size={16} strokeWidth={3} /> : <Plus size={16} strokeWidth={2.5} />}
                  {added ? "Added to Booking" : "Add to Booking"}
                </button>
              </motion.div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
  );
};
